import PropTypes from 'prop-types';

// Common PropTypes definitions for TopBar components
export const TopBarPropTypes = {
  // Display Options
  showLogo: PropTypes.bool,
  showLocation: PropTypes.bool,
  showUserIcon: PropTypes.bool,
  showCartIcon: PropTypes.bool,

  // Data Props
  brandName: PropTypes.string,
  currentLocation: PropTypes.string,
  cartCount: PropTypes.number,
  locations: PropTypes.arrayOf(PropTypes.string),
  signupOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      action: PropTypes.string.isRequired,
      description: PropTypes.string,
      icon: PropTypes.string
    })
  ),

  // User State
  isLoggedIn: PropTypes.bool,
  userInfo: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string
  }),
  userMenuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      action: PropTypes.string.isRequired,
      icon: PropTypes.string,
      showWhen: PropTypes.oneOf(['guest', 'authenticated', 'always'])
    })
  ),

  // Event Handlers
  onLocationClick: PropTypes.func,
  onUserClick: PropTypes.func,
  onCartClick: PropTypes.func,
  onSignupUser: PropTypes.func,
  onSignupPandit: PropTypes.func,
  onLogoClick: PropTypes.func,

  // State Handlers
  setShowUserDropdown: PropTypes.func,
  setShowLocationDropdown: PropTypes.func,
  setShowMobileSearch: PropTypes.func,
  setSearchTerm: PropTypes.func,

  // Styling Props
  className: PropTypes.string,
  containerMaxWidth: PropTypes.string,

  // State Props
  showUserDropdown: PropTypes.bool,
  showLocationDropdown: PropTypes.bool,
  showMobileSearch: PropTypes.bool,
  searchTerm: PropTypes.string,

  // Refs
  userDropdownRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
  locationDropdownRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),

  // Functions
  handleLocationSelect: PropTypes.func,
  handleUserMenuClick: PropTypes.func,
  handleSearch: PropTypes.func,
  formatCartCount: PropTypes.func
};
